export default "__VITE_ASSET__C7IQ2QB0__"